import { h, Component } from 'preact';
import style from './index.less'

const Tile = (props)=>{
    const classes = [style.tile];
    props.class && classes.push(props.class);
    
    if(props.selected) classes.push(style.selected);

    return (
        <div class={classes.join(' ')} onClick={props.onClick} key={props.key}>
            {props.children}
        </div>
    )
}

export default Tile



// WEBPACK FOOTER //
// ./components/elements/Tile/index.js